import t from "./highrise1312.mjs";
import o from "./highrise1313.mjs";
import r from "./highrise1314.mjs";
function f(e) {
  return t(e, r, o);
}
export {
  f as default
};
